module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 125.63c5925f.png";